<template>
    <div>
                <!-- <base-header style="background: rgba(79, 47, 129, 1); -->
background: radial-gradient(circle, rgba(79, 47, 129, 1) 25%, rgba(79, 47, 129, 0.73) 100%);" class="pb-6 pb-8 pt-4 pt-md-4">
            <!-- Card stats -->
            <!-- <div class="row">
              <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0">Icons</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div> -->
            <!-- </div> -->
        <!-- </base-header> -->

        <div class="container-fluid mt--7" style="padding-top:75px;" :dir="language">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                          <div class="row">
                          <div class="text-left col-md-8" v-if="isManager && language == 'ltr'">
                          <a href="#/createassignment" class="btn btn-success text-left" style="">{{texts.createassignment}}</a>
                          </div>

                          <div class="text-right col-md-8" v-if="isManager && language == 'rtl'">
                          <a href="#/createassignment" class="btn btn-success text-left" style="">{{texts.createassignment}}</a>
                          </div>
                          <div class="text-left col-md-8" v-if="!isManager">
                          <!-- <a href="#" class="btn btn-success text-left" style=""></a> -->
                          </div>
                          <div class="text-right col-md-2" v-if="language == 'ltr'">
                          <button id="archived_btn" class="btn btn-primary text-right" style="" v-on:click="archivedFunc()">{{texts.archived}}</button>
                          </div>
                          <div class="text-left col-md-2" v-else>
                          <button id="archived_btn" class="btn btn-primary text-left" style="" v-on:click="archivedFunc()">{{texts.archived}}</button>
                          </div>
                          <div class="text-right col-md-2" v-if="language == 'ltr'">
                          <a href="#/login" class="btn btn-primary text-right" style="">{{texts.logout}}</a>
                          </div>
                          <div class="text-left col-md-2" v-else>
                          <a href="#/login" class="btn btn-primary text-left" style="">{{texts.logout}}</a>
                          </div>
                          </div>
                            <h2 class="mb-0" style="text-align:center">{{texts.assignments}}</h2>

                        </div>
                        <div class="card-body">
                          <div class="card-header bg-transparent" v-if="assignments.length === 0 && !this.isManager">
                          <h2  style="text-align : center;font-size:24px;" class="mb-0" >You are not assigned to any assignments.</h2>
                          <br>
                          <br>
                          <center>
                          <router-link to="/login" class="btn-primary btn-lg" style="align-items:center;">

                              <span>Logout</span>
                          </router-link>
                          </center>
                          </div>
                            <div class="row icon-examples" v-if="!archived">

                                <div class="col-lg-3 col-md-6"
                                     v-for="assignment in assignments" >
                                    <button v-if="assignment.create" style="width: 200px; height: 100px; background-color: #1dd1a1; color: #fff;" type="button"
                                            v-b-tooltip.hover.top
                                            :title="assignment.name"
                                            v-on:click="selectAssignment(assignment.id, assignment.name)"
                                            class="btn-icon-clipboard" data-clipboard-text="air-baloon">
                                            <center>
                                            {{assignment.name}}
                                          </center>
                                    </button>
                                    <button v-else style="width: 200px; height: 100px;" type="button"
                                            v-b-tooltip.hover.top
                                            :title="assignment.name"
                                            v-on:click="selectAssignment(assignment.id, assignment.name)"
                                            class="btn-icon-clipboard" data-clipboard-text="air-baloon">
                                            <center>
                                            {{assignment.name}}
                                          </center>
                                    </button>
                                    <!-- <center> -->

                                    <!-- </center> -->
                                </div>
                            </div>
                            <ArchivedAssignmentsTable v-else title="Progress" :tableData="archivedassignments" @view="viewAssignment($event)"></ArchivedAssignmentsTable>
                        </div>
                    </div>
                </div>
            </div>
        </div>



    </div>
</template>

<script>
  import ProjectsTable from './Tables/ProjectsTable';
  import ArchivedAssignmentsTable from './Tables/ArchivedAssignmentsTable';
  import { mapState } from "vuex";
  import { SEND_SMS, SET_ASSIGNMENT_TITLE,SET_ASSIGNMENT_ID, GET_ASSIGNMENTS } from "@/store/actions.type";
  import store from "@/store";
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import { mapGetters } from "vuex";
  import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png'
  import OpenIcon from 'vue-beautiful-chat/src/assets/logo-no-bg.svg'
  import FileIcon from 'vue-beautiful-chat/src/assets/file.svg'
  import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg'
  import PDFObject from 'pdfobject';
  // import { SET_ASSIGNMENT_TITLE } from "@/store/actions.type";
  import JwtService from "@/common/jwt.service";
  import UserService from "@/common/user.service";

  Vue.use(VueClipboard)
  export default {
    directives: {
      'b-tooltip': BTooltipDirective
    },
    components: {flatPicker, ProjectsTable, ArchivedAssignmentsTable},
    mounted(){

  //     if (sessionStorage.getItem('reloaded') != null) {
  //     console.log('page was reloaded');
  // } else {
  //   this.$router.push({ name: "login" })
  //     console.log('page was not reloaded');
  // }
      Promise.all([
        store.dispatch(GET_ASSIGNMENTS)

      ]).then(() => {
        for (let i = 0; i < store.getters.assignments.length; i++) {
          if (Number(store.getters.assignments[i].active) === 1) {
          this.assignments.push({"id" :store.getters.assignments[i].id, "name" : store.getters.assignments[i].title, create : false});
        }
        }
        // if (JwtService.getIsManager() === 1) {
        //   this.assignments.push({"id" :"create", "name" : "Create Assignment", create : true});
        // }

      });


      console.log(store.getters);

    },
    computed: {
       ...mapGetters(["isAuthenticated", "assignments"])
       // ,
       // subscribers() {
       //     console.log(this.$route.params.subscribers);
       //   return this.$route.params.subscribers;
       // }
     },
    data() {
      return {
        isManager : JwtService.getIsManager() === 1,
        texts : {
          assignments: UserService.getLanguage() === "rtl" ? "مهام" : "Assignments",
          logout : UserService.getLanguage() === "rtl" ? "تسجيل خروج" : "Logout",
          createassignment : UserService.getLanguage() === "rtl" ? "إنشاء مهمة" : "Create Assignment",
          archived : UserService.getLanguage() === "rtl" ? "ارشيف المهام" : "Archived",
          active : UserService.getLanguage() === "rtl" ? "فعال" : "Active"
        },
        language : UserService.getLanguage() || "ltr",
        archived : false,
        title : '',
        self : this,
        pdf_url : 'http://aicj.jo/wp-content/uploads/2019/07/F.S_AICJ_31-12-2018.pdf',
        dates: {
          simple: new Date().toISOString().split(" ")[0]
        },
        archivedassignments : [],

      assignments: [
          // { name: "Bank of Jordan Risk Management",create : false},
          // { name: "Wafii Audit" ,create : false},
          // { name: "Tawanuyiah Insurance Audit", create : false },
          // { name: "Create new Assignment", create : true }
        ]
      }
    },
//     created() {
//   window.addEventListener('beforeunload', this.beforeWindowUnload)
// },
//
// beforeDestroy() {
//   window.removeEventListener('beforeunload', this.beforeWindowUnload)
// },
    methods : {
      confirmStayInDirtyForm() {
        return true && !this.confirmLeave()
      },

      beforeWindowUnload(e) {
        // this.$router.push({ name: "login" })
        // e.preventDefault();
        // e.returnValue = '';
        // if (this.confirmStayInDirtyForm()) {
        //   // Cancel the event
        //   e.preventDefault()
        //   // Chrome requires returnValue to be set
        //   e.returnValue = ''
        // }
      },
      preventNav(event) {
        // if (!this.isEditing) return
        if (this.confirmStayInDirtyForm()) {
          event.preventDefault()
          event.returnValue = ""
        }
      },
      handler(event) {
        alert(event);
        event.preventDefault();
         console.log("CLOSING");
         console.log(event);
      },
      archivedFunc() {
        console.log("CALLED ARCHIVED");
          if (this.archived) {
            this.assignments = [];
            for (let i = 0; i < store.getters.assignments.length; i++) {
              if (Number(store.getters.assignments[i].active) === 1) {
                  this.assignments.push({"id" :store.getters.assignments[i].id, "name" : store.getters.assignments[i].title, create : false});
              }
            }
            this.archived = false;
            this.texts.assignments = UserService.getLanguage() === "rtl" ? "مهام" : "Assignments";
            document.getElementById("archived_btn").innerText = this.texts.archived;
          }
          else {
            this.archivedassignments = [];
            for (let i = 0; i < store.getters.assignments.length; i++) {
              if (Number(store.getters.assignments[i].active) === 0) {
                  this.archivedassignments.push({"id" :store.getters.assignments[i].id, "title" : store.getters.assignments[i].title, "description" : store.getters.assignments[i].description, "startdate" : store.getters.assignments[i].startdate, "enddate" :store.getters.assignments[i].enddate,  create : false});
              }
            }
            console.log(this.archivedassignments);
            this.archived = true;
            this.texts.assignments = UserService.getLanguage() === "rtl" ? "المهام المؤرشفة" : "Archived Assignments";
            document.getElementById("archived_btn").innerText = this.texts.active;
          }
      },
      selectAssignment(assignmentId, assignmentTitle) {
        if (assignmentId === "create" && JwtService.getIsManager() === 1) {
          this.$router.push({ name: "createassignment" });
        }
        else {
          console.log("SELECTED ASSIGNMENT : " + assignmentId);
          Promise.all([
            store.dispatch(SET_ASSIGNMENT_ID, assignmentId),
            store.dispatch(SET_ASSIGNMENT_TITLE, assignmentTitle),

          ]).then(() => {
            sessionStorage.setItem('reloaded', 'yes');
              this.$router.push({ name: "overview" });
              this.isLoading = false;

          });
        }
      },
      viewAssignment(token) {
        Promise.all([
          store.dispatch(SET_ASSIGNMENT_ID, token.id),
          store.dispatch(SET_ASSIGNMENT_TITLE, token.title),

        ]).then(() => {
            this.$router.push({ name: "overview" });
            this.isLoading = false;

        });
      },

      onSubmit() {
        // console.log("TITLE : " + this.title);
        // console.log("MESSAGE : " + this.message);
        // console.log("TIMESLOT : " + this.timeslot);
        // console.log("TIERS : ");
        // console.log(this.tiers);
        // console.log("DATE : " + this.dates.simple);
            if (this.phone_no !== '' ) {
                this.localerrors = null;


                let formData = {'phone_no':this.phone_no};
                console.log(formData);
                Promise.all([
                  store.dispatch(SEND_SMS, formData),

                ]).then(() => {
                    this.isLoading = false;

                });
            }
            else {

              this.localerrors = "Phone cannot be empty !"

            }

          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        },
      onChange(event) {
          this.timeslot = event.target.value;
          console.log(event);
      },

      onCopy() {
        this.$notify({
          type: 'success',
          title: 'Copied to clipboard'
        })
      }
    }
  };
</script>

<style></style>
